export default __webpack_public_path__ + "static/media/ChristineJones-7.2892ac37.jpg";